// extracted by mini-css-extract-plugin
module.exports = {"icon":"style_icon__1NQv8","button":"style_button__3siu7","closeService":"style_closeService__2wRvn"};